import { render, staticRenderFns } from "./Markers.vue?vue&type=template&id=486ee032&scoped=true"
import script from "./Markers.vue?vue&type=script&lang=js"
export * from "./Markers.vue?vue&type=script&lang=js"
import style0 from "./Markers.vue?vue&type=style&index=0&id=486ee032&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486ee032",
  null
  
)

export default component.exports